import React, { useState, useEffect, ChangeEvent } from 'react';
import {
  Dialog,
  DialogTitle,
  DialogContent,
  DialogActions,
  TextField,
  Button,
} from '@mui/material';
import { SnapshotAlarm } from '../../types';

interface Props {
  open: boolean;
  handleClose: () => void;
  selectedAlarm: SnapshotAlarm;
  handleAlarmUpdated: (alarm: SnapshotAlarm) => void;
}
const AlarmEditDialog = ({
  open,
  handleClose,
  selectedAlarm,
  handleAlarmUpdated,
}: Props) => {
  const [alarm, setAlarm] = useState<SnapshotAlarm>(selectedAlarm);

  useEffect(() => {
    setAlarm(selectedAlarm);
  }, [selectedAlarm]);

  const handleChange = (e: ChangeEvent<HTMLInputElement>) => {
    const { name, value } = e.target;
    setAlarm({
      ...alarm,
      [name]: value,
    });
  };

  return (
    <Dialog open={open} onClose={handleClose} fullWidth maxWidth='xs'>
      <DialogTitle>Edit Alarm</DialogTitle>
      <DialogContent>
        <TextField
          id='name'
          label='Alarm Name'
          name='name'
          value={alarm?.name || ''}
          onChange={handleChange}
          margin='dense'
          fullWidth
          required
        />
      </DialogContent>
      <DialogActions>
        <Button onClick={handleClose} color='secondary' variant='contained'>
          Cancel
        </Button>
        <Button
          color='primary'
          variant='contained'
          onClick={() => handleAlarmUpdated(alarm)}
        >
          Submit
        </Button>
      </DialogActions>
    </Dialog>
  );
};

export default AlarmEditDialog;
